<template>
  <v-dialog
    persistent
    max-width="480"
    :value="show"
  >
    <v-card>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-card-text class="whitespace-pre-wrap">
        {{message}}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" v-on:click="close">閉じる</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import store from '@/store'

export default {
  name: 'CErrorDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    message () {
      const str = this.getters['api/errors'].join('\n')
      const str2 = str.trim()
      const message = str2.replace('Error:', '')
      return message
    }
  },
  methods: {
    async close () {
      this.errors = []
      this.show = false

      // 予約情報を初期化する
      const stationID = store.getters['book/stationID']
      await store.dispatch('book/init', { stationID })

      // ログイン情報をクリアする
      await this.dispatch('user/clear', true)

      // トップページへ戻る
      // const url = this.getters['org/topRoute']
      const url = this.getters['org/topURL']
      window.location.href = url
    }
  }
}
</script>
